import { render, staticRenderFns } from "./ContactsDetailsTable.vue?vue&type=template&id=26107252&scoped=true&"
import script from "./ContactsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ContactsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactsDetailsTable.vue?vue&type=style&index=0&id=26107252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26107252",
  null
  
)

export default component.exports